import React from 'react';
import SibilusNavbar from '../../c/Navbar';
import Footer from '../../c/Footer';
import { Container, Row, Col } from 'reactstrap';
import { T } from '../../traks';
import { LL } from '../../c/LL';

const FrontPage = () => {
	return (<>
		<SibilusNavbar />
		<Container className="py-5 my-5">
			<Row className="justify-content-center">
				<Col xs={12} md={8} lg={6} className="text-center">
					<h1 className="fw_600 mb-4"><T>Welcome to Pentus</T></h1>
					<a href={LL('/login')} className="btn btn_green px-5 py-2 text-white font_18px mb-5" data-cy="login-btn">
						<T>Login</T>
					</a>
					<hr className="my-5" />
					<div className="font_16px">
						<div className="fw_600 mb-3">Pentus ApS</div>
						<div>Flakhaven 1, 1.</div>
						<div>DK-5000 Odense C</div>
						<div className="mb-3"><T>Denmark</T></div>
						<div><a href="mailto:info@pentus.dk">info@pentus.dk</a></div>
					</div>
				</Col>
			</Row>
		</Container>
		<Footer />
	</>);
};

export default FrontPage;
